import { render } from "./featuredTemplates.vue?vue&type=template&id=2f1fbd02"
import script from "./featuredTemplates.vue?vue&type=script&lang=js"
export * from "./featuredTemplates.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__